import { z } from 'zod';
// ── Schema Zod de base (pagination + search) ─────────────────────────────────
export const PaginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
    search: z.string().optional(),
});
// PaginationDto (createZodDto) défini côté API — nestjs-zod n'est pas une dep de @cpce/shared
// ── Helpers Zod pour les types de filtres courants ───────────────────────────
export const DateRangeSchema = z.object({
    dateFrom: z.string().date().optional(),
    dateTo: z.string().date().optional(),
});
export const NumericRangeSchema = z.object({
    amountMin: z.coerce.number().optional(),
    amountMax: z.coerce.number().optional(),
});
// tableau de strings (enum/badge-enum filters)
export const StringArraySchema = z.array(z.string());
// tableau d'ids (foreign key filters)
export const NumberArraySchema = z.array(z.coerce.number());
